import { EntityAdapter, createEntityAdapter } from '@reduxjs/toolkit';
import { Entity } from '../../../models/common';

export const createStringIdAdapter = <TData>(useCaseSensitiveIds = false): EntityAdapter<Entity<TData>> =>
    createEntityAdapter<Entity<TData>>({
        selectId: (entity) => (useCaseSensitiveIds ? entity.id : entity.id.toLowerCase()),
    });
